import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20illustration%2C%20fantasy%20world%20with%20floating%20comic%20panels%2C%20dramatic%20sunset%20sky%20with%20warm%20orange%20and%20coral%20tones%2C%20silhouette%20of%20characters%2C%20cinematic%20atmosphere%2C%20webtoon%20aesthetic%2C%20stylized%20art%2C%20dreamy%20yet%20powerful%20composition%2C%20soft%20gradient%20skies%2C%20no%20text&width=1800&height=900&seq=manhwa-hero-bg&orientation=landscape"
        alt="韩国漫画网 - 免费韩漫在线阅读"
        title="韩国漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              无遮挡下拉式
              <br />
              <span className="text-primary-300">韩国漫画</span>在线阅读
            </h1>
            <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg leading-relaxed">
              免费漫画大全，好看韩漫推荐。沉浸式下拉阅读体验，告别翻页烦恼，让您完全沉浸在精彩的漫画世界中。每日更新，分类齐全，满足你的所有阅读需求。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/romance"
                className="bg-primary-500 text-background-50 text-sm px-6 py-3 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                立即开始阅读
              </Link>
              <Link
                to="/category/fantasy"
                className="bg-background-50/20 backdrop-blur-sm text-background-50 text-sm px-6 py-3 rounded-full hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/30"
              >
                热门推荐
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">1000+</p>
                <p className="text-xs text-background-50/60">漫画资源</p>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">8大</p>
                <p className="text-xs text-background-50/60">分类齐全</p>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">每日</p>
                <p className="text-xs text-background-50/60">持续更新</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}